export default __webpack_public_path__ + "static/media/fintoc_payku.e363ac2b.webp";